import { render, staticRenderFns } from "./SendDocModal.vue?vue&type=template&id=036446ed&scoped=true&"
import script from "./SendDocModal.vue?vue&type=script&lang=ts&"
export * from "./SendDocModal.vue?vue&type=script&lang=ts&"
import style0 from "./SendDocModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SendDocModal.vue?vue&type=style&index=1&id=036446ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036446ed",
  null
  
)

export default component.exports